import { useCallback } from "react";

import AIPlayerSummaryEmptyStateView from "./AIPlayerSummaryEmptyStateView";

/**
 * Props interface for AIPlayerSummaryEmptyStateContainer component
 */
interface AIPlayerSummaryEmptyStateContainerProps {
  isDark: boolean;
  isSmallScreen: boolean;
  onRefresh: () => void;
}

/**
 * AIPlayerSummaryEmptyStateContainer component - manages empty state logic
 *
 * Handles the empty state display when no AI summary is available.
 * Provides a "Generate Summary" button that triggers initial generation.
 * @param props - Component props
 * @param props.isDark - Whether dark theme is active
 * @param props.isSmallScreen - Whether the screen is small (mobile)
 * @param props.onRefresh - Callback to generate the summary
 */
function AIPlayerSummaryEmptyStateContainer({
  isDark,
  isSmallScreen,
  onRefresh,
}: AIPlayerSummaryEmptyStateContainerProps) {
  const handleRefresh = useCallback(() => {
    onRefresh();
  }, [onRefresh]);

  return (
    <AIPlayerSummaryEmptyStateView
      isDark={isDark}
      isSmallScreen={isSmallScreen}
      onRefresh={handleRefresh}
    />
  );
}

export default AIPlayerSummaryEmptyStateContainer;
